import { Component, OnInit, AfterViewInit, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { CookieService } from "ngx-cookie-service";
import { ComponentMenuBar } from '../../component-ui/menu-bar/component';

@Component({
  selector: 'app-learning-camp',
  templateUrl: './learning-camp.component.html',
  styleUrls: ['./learning-camp.component.css']
})
export class LearningCampComponent implements OnInit, AfterViewInit {

  //学习地图信息
  @Input() themeBG: string; //主题背景
  @Input() isShowEnterAnimate: boolean; //是否显示切换动画

  @ViewChild('menuBar')
  menuBar: ComponentMenuBar;
  skuId: any;
  methodId: any;
  campName: string = "";
  campTour: any;
  campTourMetas: any;
  userId:any; //用户id
  report: any;
  companyMetaId: number;
  assetsRoute: string = "../../assets";
  progressLists: any;
  progress: number = 0;
  isPC: boolean = false;
  isShowIntroduction: boolean = false;
  startEvent: boolean = false;//开始记录event,防止在返回按钮时又调用一次event
  isShowReport: boolean = false;
  isShowTip: boolean = false;
  isCampEnd: boolean = false;
  isShowGDPR: boolean = false;
  gdprStatus: string = "";
  onceResult: any;
  count: number = 0;
  isShowWechatNotice: boolean = false;
  isShowToast: boolean = false;
  campToast: string = "";
  loadFinished: boolean = false;
  constituteId: number;
  exerciseBook: any;
  campId:number;
  isHaveTools: boolean = false;
  isShowGuide: boolean = false;
  AO: any;
  startDayTitle : string = "";
  startDayCon : string = "";
  projectId: string;
  circleTheme = {
    'width': 300, //环形长度
    'height': 300, //环形高度
    'x': 0, //圆心x坐标
    'y': 0, //圆心y坐标
    'radius': 90, //外环半径
    'innerRadius': 20, //圆环厚度
    'startAngle': 0, //开始角度
    'endAngle': 360, //结束角度
    'angleRadian': 275, //环形轨迹角度
    'colors': ['#7E9FFB','#5F81DB','#60B68A','#44976C','#EEE'] //环形颜色
  }//主题
  constructor(private route: ActivatedRoute,
              private router: Router,
              private apiService: ApiService,
              private cookieService: CookieService,
              private commonService: CommonService) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.skuId = params['skuId'];
      this.campId = Number(params['campId']);
      this.methodId = params['methodId'] ? params['methodId'] : null;
      this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
      this.isPC = !!localStorage.getItem('isPC');
      this.projectId = localStorage.getItem("projectId")


      this.getTrainingCampCourse(this.skuId).then(result=>{
        console.log(result);
        this.campTour = result;
        // this.campName = result.name;
        this.campName = result['campName'];
        this.userId = result['userId'];
        this.campTourMetas = result['campMetasLearningPathMetasRelations'];
        if(this.campTourMetas[0].learningPathMetasId === -40401 || this.campTourMetas[0].learningPathMetasId === -42401){
          this.startDayTitle = this.campTourMetas[0].pathTitle;
          this.startDayCon = this.campTourMetas[0].pathName;
        }

      })
        .then(()=>{
        return this.getUserExerciseBookAPI(0,0).then(result=>{
          return this.exerciseBook = result
        })
      }).then(()=>{
        return this.getLastActualOperationAPI(this.campId).then(result=>{
          return this.AO = result;
        })
      }).then(()=>{
        return this.getUserHaveTools().then(result=>{
          return this.isHaveTools = result;
        })
      }).then(()=>{
        return this.commonService.getOnceIno(99999).then(result=>{
          return this.isShowGuide = result !== 1;
        })
      })
      .then(()=>{
        // let type = this.report.achievementLvl === -1 ? 7 : 8;
        let type = 7;
        return this.commonService.getOnceIno(this.commonService.getOnceValue(this.skuId,type)).then(result=>{
          return this.onceResult = result;
        })
      })

      .then(()=>{
        this.loadFinished = true;
        this.constituteId = this.AO['constituteId'];
        // this.isCampEnd = this.report.achievementLvl === -1 ? false : true;
        // this.isShowIntroduction = this.isCampEnd ? false : this.onceResult === 1 ? false : true;
        if(this.onceResult !== 1){
          this.isShowIntroduction = true;
          this.startEvent = true;
          this.apiService.learingTime({module:this.campTour.campName + "训练营",type:1,btnName:'训练营介绍页',courseUnit:Number(this.skuId),userId:this.userId}).subscribe(result=>{
            console.log("开始记录介绍页的埋点",result);
          });
        }
        // this.isShowReport = this.isCampEnd ? this.onceResult === 1 ? false : true : false;
        this.setProgressInLearningTour();
      })
    });
    //训练营心跳清除数据
    if(localStorage.getItem("learningPathMetasId")){
      localStorage.removeItem("learningPathMetasId");
    }
    if(localStorage.getItem("learningPathMetaId")){
      localStorage.removeItem("learningPathMetaId");
    }
    $('#learningPathMetaIdContainer').val("");
  };

  ngAfterViewInit() {
    this.commonService.initPage({
      'backgroundColor': '#F2F3FA'
    });
  }

  //获取用户所有训练营下面的练习册
  getUserExerciseBookAPI(campId: any,status: number):Promise<any>{
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/camp/applicationPractice/exerciseBook?campMetasId=' + campId + '&status=' + status
    }).toPromise();
  }

  //获取day7的实战作业
  getLastActualOperationAPI(campId:number):Promise<void>{
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/camp/applicationPractice/actualOperation/lastDay/' + campId
    }).toPromise();
  }


  //获取训练营课程
  getTrainingCampCourse(skuId){
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/camp/everyDayTask/'+skuId
      // 'url': 'sr/learningTourTrainingCamp/'+skuId
    }).toPromise();
  }

  /**
   *校验用户是否有小工具权限
   */
  getUserHaveTools():Promise<any>{
    return this.apiService.ajax({
      'type': 'GET',
      'url':'/sr/tools/yyToolsLibrary/haveToolsAuthority'
    }).toPromise();
  }

  //将进度数据插入learningTour
  setProgressInLearningTour(){
    this.getUserCampProgress(this.campId).then(result=>{
      this.progressLists = result;
    }).then(()=>{
      for(let i = 0, len = this.campTourMetas.length; i<len; i+=1){
        this.campTourMetas[i].progress = this.progressLists.length!==0 ? this.progressLists[i]['progress']:0;
      }
    })
  }

  //进入实战作业
  goActualCombatWork():void{
    if(this.AO['status'] < 20){
      if(this.methodId){
        this.router.navigate(["exercise-work",this.constituteId],{queryParams:{"isLastDay":1,"onlyCamp":1}});
      }else{
        this.router.navigate(["exercise-work",this.constituteId],{queryParams:{"isLastDay":1}});
      }
    }else{
      console.log(this.methodId)
      if(this.methodId){
        this.router.navigate(['learning-camp-response'],{queryParams:{tabNum:0,'constituteId':this.constituteId,"onlyCamp":1,"isLastDay":1}}).then();
      }else{
        this.router.navigate(['learning-camp-response'],{queryParams:{tabNum:0,'constituteId':this.constituteId,"isLastDay":1}}).then();
      }

    }
  }

  /**
   * 进入工具
   */
  goTools():void{
    this.isShowGuide = false;
    this.menuBar.goTools();
  }

  //进入能力列表
  goLearnPath(learningMetaId:number,index:number,flag:boolean):void{
    if(this.isShowToast){
      return;
    }else{
      this.campToast = "这位积极的同学，此部分课程将在<br />"+ this.campTourMetas[index < 0 ? this.campTourMetas.length -1 : index]['trainingCampLockDate'] +"准时解锁！";
      localStorage.setItem("campCourseDay",this.campTourMetas[index < 0 ? this.campTourMetas.length -1 : index]['pathTitle']);
      if(!flag){
        if(index == 0){
          let learningMetaIdValue = Math.abs(learningMetaId);//取绝对值
          let learningMetaIds = Number(String(learningMetaIdValue).slice(0,String(learningMetaIdValue).length-2));
          if(this.campId === 2){
            learningMetaIds = 414;//因为互联网没有day0和day14所以不需要截取
          }
          //day0
          this.router.navigate(['learning-path',learningMetaIds],{queryParams:{firstDay:1}});
          localStorage.setItem('learningPathMetasId',this.campTourMetas[0]['learningPathMetasId']);
          // localStorage.setItem("campCourseDay",this.campTour.campMetasLearningPathMetasRelations[0].sort);
        }else if(index < 0){
          let learningMetaIdValue = Math.abs(learningMetaId);//取绝对值
          let learningMetaIds = Number(String(learningMetaIdValue).slice(0,String(learningMetaIdValue).length-2));
          if(this.campId === 2){
            learningMetaIds = 414;//因为互联网没有day0和day14所以不需要截取
          }
          //day14
          this.router.navigate(['learning-path',learningMetaIds],{queryParams:{isLastDay:1}});
          localStorage.setItem('learningPathMetasId',this.campTourMetas[this.campTourMetas.length -1]['learningPathMetasId']);
          // localStorage.setItem("campCourseDay",this.campTour.campMetasLearningPathMetasRelations[this.campTour.campMetasLearningPathMetasRelations.length-1].sort);
        }else{
          this.router.navigate(['learning-path',learningMetaId]);
          // localStorage.setItem("campCourseDay",this.campTour.campMetasLearningPathMetasRelations[index].sort);
        }
      }else{
        this.isShowToast = true;
        setTimeout(()=>{
          this.isShowToast = false;
        },2000);
      }
    }

  }

  //根据条件在数组中获取下标
  getIndexByConditionIdInLists(Lists,condition,value){
    return (Lists||[]).findIndex((v)=>v[condition] === value);
  }

  //获取用户进度
  getUserLearningProgress(){
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/user/learning/progress',
    }).toPromise();
  }

  /**
   * 获取训练营课程进度
   * @param campId:Number  训练营Id
   */
  getUserCampProgress(campId:number):Promise<any>{
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/camp/dayProgress?campMetaId='+ campId
    }).toPromise();
  }

  //获取用户结业报告
  getUserGraduateReport(userId,skuId){
    return this.apiService.ajax({
      'type':'GET',
      // 'url': 'http://m-uat.transtalent.cn/ddilearner/v1/camp/achievement/'+userId+'/'+skuId
      'url': 'ddilearner/v1/camp/achievement/'+userId+'/'+skuId
    }).toPromise();
  }

  //显示旅程地图
  showEnterAnimate(){
    this.isShowIntroduction = true;
    this.commonService.learningPortEventLog({
      "eventType" : "introduction_learning_journey",
      "eventSubType" : ""
    }).then();
  }

  //显示结营回顾
  showEnterReport(){
    this.isShowReport = true;
    this.commonService.learningPortEventLog({
      "eventType" : "journey_review",
      "eventSubType" : ""
    }).then();
  }

  //关闭旅程地图
  closeLearningCampIntroduction(){
    this.isShowIntroduction = false;
    if(this.startEvent){
      this.apiService.learingTime({module:this.campTour.version + this.campTour.campName + "训练营",type:2,btnName:'训练营介绍页',userId:this.userId}).subscribe(result=>{
        console.log("开始记录介绍页的埋点",result);
      });
    }
  }

  //关闭结营仪式
  closeLearningCampReport(){
    this.isShowReport = false;
  }

  goToLearningMap(){  // 返回
    // this.router.navigate(['learning-map']);
    if(this.projectId){
      this.router.navigate(['learning-project', this.projectId]);
    } else {
      this.router.navigate(['learning-map']);
    }
  }

  // 显示提示框
  showComponentTip(){
    this.isShowTip = true;
  }

  // 关闭提示框
  closeComponentTip(){
    this.isShowTip = false;
    this.menuBar.showOrCloseFullPage();
  }

  //关闭GDPR
  closeGDPR(){
    this.isShowGDPR = false;
    this.gdprStatus = "";
    setTimeout(()=>{
      this.menuBar.showOrCloseFullPage();
    },100);
  }

  //显示GDPR
  showGDPR(){
    this.isShowGDPR = true;
    setTimeout(()=>{
      this.gdprStatus = "open";
    },100);
  }

  //微信提醒按钮
  showWechatNotice(){
    this.count++;
    if(this.count > 20){
      this.isShowWechatNotice = true;
      this.count = 0;
    }
  }

  menuBarClick():void{
    this.menuBar.showOrCloseFullPage();
  }

  closeWechatNotice(){
    this.isShowWechatNotice = false;
  }

  // 登出
  logout(){
    this.apiService.logout().subscribe(res => {
      if(res){
        console.log(res,'登出接口');
        this.isShowTip = false;
        //清除多公司记录
        this.commonService.clearLoginCredentials();
        localStorage.removeItem('themeBG');
        localStorage.removeItem('userId');
        localStorage.removeItem('transtalen-token');
        localStorage.removeItem('transtalenuserid');
        this.router.navigate(['new-login']);
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/learning-camp/learning-camp.component.ts